import { useTranslation } from 'react-i18next';

import UploadPdfButton from '@/components/UploadPDFButton/UploadPdfButton';
import Pointer from '@/icons/pointer.svg';
import PreFooter2x from '@/images/pre-footer2x.webp';
import PreFooter from '@/images/pre-footer.webp';

function Prefooter({ withImage = true }) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col-reverse items-center lg:mb-20 lg:flex-row">
			{withImage && (
				<div className="justify-start py-0 pb-0 pt-12 text-left text-sm text-grey-500 underline-offset-4 hover:underline lg:mr-[114px] lg:p-0">
					<img
						src={PreFooter}
						srcSet={`${PreFooter} 1x, ${PreFooter2x} 2x`}
						alt="Logo"
						loading="lazy"
					/>
				</div>
			)}

			<div className="flex flex-col items-center gap-4 lg:items-start lg:justify-start lg:gap-6">
				<h1 className="font-title text-[32px] font-bold leading-10 text-white lg:text-start lg:text-[40px] lg:leading-[52px]">
					{t('footer.title')}
				</h1>
				<div className="relative">
					<UploadPdfButton variant="outlineWhite" />
					<Pointer className="absolute -bottom-4 -right-14 hidden text-white lg:block" />
				</div>
			</div>
		</div>
	);
}

export default Prefooter;
